<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  {{data.message}}
  @if(data?.notes){
    <form class="form">
      <p>Note:</p>
      <mat-form-field class="input-large" appearance="outline">
        <textarea matInput [formControl]="notes">
        </textarea>
      </mat-form-field>
    </form>
  }

</mat-dialog-content>
<mat-dialog-actions>
 <button mat-button (click)="onCancel()">Annulla</button>
  <button mat-button color="warn" (click)="onConfirm()">Conferma</button>
</mat-dialog-actions>
